import client from '../../http-client';

const api = {
	get: (data = {}) => {
		return client.post('t10s/get', {
			TranslationService: 'get',
			json_payload: JSON.stringify(data)
		});
	}
};

export default api;
